import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RoutePath } from '@nano/common/routing/routing';
import { AuthService } from '@nano/core/auth';

@Injectable({ providedIn: 'root' })
export class LoggedInGuard {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate(): boolean {
    return this.checkUserAuthorized();
  }

  canActivateChild(): boolean {
    return this.canActivate();
  }

  canLoad(): boolean {
    return this.checkUserAuthorized();
  }

  checkUserAuthorized(): boolean {
    if (this.authService.isAuthorized()) {
      return true;
    }
    void this.router.navigate([`/${RoutePath.login}`]);
    return false;
  }
}
